export const codeSnippet = {
  code1: `BEGIN
   FOR rec IN (SELECT id, salary FROM employees) LOOP
      IF rec.salary > 10000 THEN
         DBMS_OUTPUT.PUT_LINE('High salary: ' || rec.id);
      END IF;
   END LOOP;
END;`,
  code2: `CREATE OR REPLACE PROCEDURE get_user_name (
    p_user_id IN NUMBER,
    p_name OUT VARCHAR2
) AS
BEGIN
    SELECT name INTO p_name FROM users WHERE id = p_user_id;
END;`,
  code3: `@Repository
public interface UserRepository extends JpaRepository<User, Long> {

    @Procedure(name = "get_user_name")
    String getUserName(@Param("p_user_id") Long userId);
}`,
  code4: `@Entity
@NamedStoredProcedureQuery(
    name = "get_user_name",
    procedureName = "get_user_name",
    parameters = {
        @StoredProcedureParameter(mode = ParameterMode.IN, name = "p_user_id", type = Long.class),
        @StoredProcedureParameter(mode = ParameterMode.OUT, name = "p_name", type = String.class)
    }
)
public class User {
    @Id
    private Long id;
}`,
  code5: `@Autowired
private EntityManager entityManager;

public String getUserName(Long userId) {
    StoredProcedureQuery query = entityManager
        .createStoredProcedureQuery("get_user_name");

    query.registerStoredProcedureParameter("p_user_id", Long.class, ParameterMode.IN);
    query.registerStoredProcedureParameter("p_name", String.class, ParameterMode.OUT);

    query.setParameter("p_user_id", userId);

    query.execute();

    return (String) query.getOutputParameterValue("p_name");
}`,
  code6: `CREATE OR REPLACE PROCEDURE get_bonus (
    p_salary IN NUMBER,
    p_bonus OUT NUMBER
) AS
BEGIN
    p_bonus := p_salary * 0.1;
END;`,
  code7: `CREATE OR REPLACE FUNCTION calculate_bonus (
    p_salary NUMBER
) RETURN NUMBER
IS
BEGIN
    RETURN p_salary * 0.1;
END;`,
  code8: `SELECT c.name, o.amount
FROM customers c
INNER JOIN orders o
ON c.id = o.customer_id;`,
  code9: `SELECT c.name, o.amount
FROM customers c
LEFT JOIN orders o
ON c.id = o.customer_id;`,
  code10: `SELECT c.name, o.amount
FROM customers c
RIGHT JOIN orders o
ON c.id = o.customer_id;`,
  code11: `SELECT c.name, o.amount
FROM customers c
FULL OUTER JOIN orders o
ON c.id = o.customer_id;`,
  code12: `SELECT name FROM employees_us
UNION
SELECT name FROM employees_india;`,
  code13: `SELECT customer_id, SUM(amount) as total_spent
FROM orders
GROUP BY customer_id;`,
  code14: `SELECT dept, SUM(salary) as total_salary
FROM employees
GROUP BY dept
HAVING SUM(salary) > 10000;`,
  code15: ``,
  code16: ``,
  code17: ``,
  code18: ``,
  code19: ``,
  code20: ``,

}

